module.exports = __webpack_public_path__ + "static/media/s_speed_skating.bde5b849.mp3";